import React from 'react'
import { ActiveObjectContext } from '../active-object-context'
import type { ActiveObjectContextValue } from '../types/active-object-context-value'

export function useActiveObject(): ActiveObjectContextValue {
  const ctx = React.useContext(ActiveObjectContext)

  if (!ctx) {
    throw new Error('useActiveObject must be used within an ActiveObjectProvider')
  }

  return ctx
}

/** Non-throwing variant for components that may render without the provider (tests, storybook),
 *  e.g. TextRenderer reporting overflow state and TypePanel reading it. */
export function useActiveObjectOptional(): ActiveObjectContextValue | null {
  return React.useContext(ActiveObjectContext)
}
